<script setup lang="ts">
// Root component. The HomeView renders standalone (no app shell);
// inner pages will render inside an AppLayout component added later.
import { RouterView } from 'vue-router';
</script>

<template>
  <RouterView />
</template>
